import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import Setting from "../../components/Setting/SettingLayer";


const SettingPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings" />

        {/* Setting */}
        <Setting />

      </MasterLayout>

    </>
  );
};

export default SettingPage; 
